import { render } from "./ModalStack.vue?vue&type=template&id=09222660"
import script from "./ModalStack.vue?vue&type=script&lang=js"
export * from "./ModalStack.vue?vue&type=script&lang=js"
script.render = render

export default script